import {createReducer, on} from '@ngrx/store';
import {toastBannerError, toastBannerSuccess, toastBannerWarning} from '../actions/toastBanner.action';

export interface ToastBannerState {
    title: string;
    body: string;
    type: string;
}

const initialState: ToastBannerState = {
    title: '',
    body: '',
    type: ''
};

export const toastBannerReducer = createReducer(
    initialState,
    on(toastBannerSuccess, (state, payload) => ({ ...state, title: payload.title, body: payload.body, type: 'success'})),
    on(toastBannerWarning, (state, payload) => ({ ...state, title: payload.title, body: payload.body, type: 'warning'})),
    on(toastBannerError, (state, payload) => ({ ...state, title: payload.title, body: payload.body, type: 'error'})),
);


